import { render, staticRenderFns } from "./AttendanceCalendar.vue?vue&type=template&id=0163d085&scoped=true&"
import script from "./AttendanceCalendar.vue?vue&type=script&lang=js&"
export * from "./AttendanceCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceCalendar.vue?vue&type=style&index=0&id=0163d085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163d085",
  null
  
)

export default component.exports